'use client'
import { defaultUser, UserIdResponseType } from "@/types";
import { getUserId, deleteUser } from "@/app/api";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { CpfMask, CnpjMask, Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";

export function DeleteUser({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [userData, setUserData] = useState<UserIdResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getUserId(id)
                if (response !== undefined) {
                    setUserData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id]);
    const user = userData || defaultUser

    const userIdentifier = user.identifier.length <= 11 ? CpfMask(user.identifier) : CnpjMask(user.identifier)

    const handleDeleteUser = async () => {
        setLoading(true)
        try {
            const res = await deleteUser(id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir usuário: ", err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableHeader>Tipo</TableHeader>
                            <TableHeader>Data do cadastro</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{user.code}</TableCell>
                            <TableCell>{user.userName}</TableCell>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableCell>
                                {user.role === 'ADMIN' ? 'Admin'
                                    : user.role === 'CLIENT' ? 'Cliente'
                                        : user.role === 'SELLER' ? 'Vendedor'
                                            : user.role === 'ACCOUNTANT' ? 'Contador'
                                                : user.role === 'INACTIVE' ? 'Inativo'
                                                    : user.role === 'CANCELED' ? 'Cancelado'
                                                        : 'Usuário'
                                }
                            </TableCell>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Observação</TableHeader>
                            <TableCell colSpan={6}>{user.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableCell>{user.code}</TableCell>
                            <TableHeader>Empresa</TableHeader>
                            <TableCell>{user.userName}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{user.name}</TableCell>
                            <TableHeader>Email</TableHeader>
                            <TableCell>{user.email}</TableCell>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableHeader>Tipo</TableHeader>
                            <TableCell>
                                {user.role === 'ADMIN' ? 'Admin'
                                    : user.role === 'CLIENT' ? 'Cliente'
                                        : user.role === 'SELLER' ? 'Vendedor'
                                            : user.role === 'ACCOUNTANT' ? 'Contador'
                                                : user.role === 'INACTIVE' ? 'Inativo'
                                                    : user.role === 'CANCELED' ? 'Cancelado'
                                                        : 'Usuário'
                                }
                            </TableCell>
                            <TableHeader>Data do cadastro</TableHeader>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{user.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>



            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir esse usuário? Essa ação não poderá ser desfeita."
                onConfirm={handleDeleteUser}
                onCancel={() => setOpenMessage(false)}
            />

        </div>
    )
}